import React, { Suspense, lazy } from "react"
import {
  Switch,
  Route,
  Redirect,
  useLocation,
  useHistory,
  useParams,
} from "react-router-dom"

import Loading from "../components/template-parts/Loading"
import Header from "../components/template-parts/Header"
import Footer from "../components/template-parts/Footer"
import Reload from "./Reload"

const AsyncLocationLanding = lazy(
  () => import("../components/pages/LocationLanding"),
)
const AsyncLocationLandingAceable = lazy(
  () => import("../components/pages/LocationLandingAceable"),
)
const AsyncLocationLandingFresno = lazy(
  () => import("../components/pages/LocationLandingFresno"),
)
const AsyncLocationLandingState = lazy(
  () => import("../components/pages/LocationLandingState"),
)
const AsyncLocationLandingStateIn = lazy(
  () => import("../components/pages/LocationLandingStateIn"),
)
const AsyncLocationLandingStateIl = lazy(
  () => import("../components/pages/LocationLandingStateIl"),
)
const AsyncLocationLandingHighschool = lazy(
  () => import("../components/pages/LocationLandingHighschool"),
)
const AsyncSearch = lazy(() => import("../components/pages/Search"))
const AsyncPracticeTests = lazy(
  () => import("../components/pages/PracticeTests"),
)
const AsyncReviews = lazy(() => import("../components/pages/Reviews"))
const AsyncAffiliateSignUp = lazy(
  () => import("../components/pages/AffiliateSignUp"),
)
// For landing pages/fast routes. Can't load firebase/redux.

const HIDE_NAV_URLS: string[] = []

/**
 * This is a temporary redirect function we need until we can update all of our
 * ads in Google Ads. It should be removed once those are updated. - MH 12/12/2022
 */
const RedirectFromDriversEd = () => {
  const location = useLocation()
  const history = useHistory()
  const { state } = useParams<{ state: string }>()

  const query = new URLSearchParams(location.search).toString()
  const newUrl = `/${state}/course/drivers-ed?${query}`
  history.push(newUrl)
  return null
}

const StaticApp = () => {
  const { pathname } = useLocation()
  return (
    <>
      <Header isConnected={false} hideNav={HIDE_NAV_URLS.includes(pathname)} />
      <div className="main-wrapper">
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path="/">
              <Reload />
            </Route>
            <Route exact path="/location/amador-valley-driving-school">
              <Redirect to="/location/Pleasanton" />
            </Route>
            <Route exact path="/state/in">
              <AsyncLocationLandingStateIn />
            </Route>
            <Route exact path="/state/il">
              <AsyncLocationLandingStateIl />
            </Route>
            <Route exact path="/state/:id">
              <AsyncLocationLandingState />
            </Route>
            <Route exact path="/ca/location/Fresno">
              <AsyncLocationLandingFresno />
            </Route>
            <Route exact path="/:state/location/:id">
              <AsyncLocationLanding />
            </Route>
            <Route exact path="/location/:id">
              <AsyncLocationLanding />
            </Route>
            <Route exact path="/lesson-partner/:partner/:state">
              <AsyncLocationLandingAceable />
            </Route>
            <Route exact path="/book">
              <AsyncSearch />
            </Route>
            <Route exact path="/partner/book">
              <AsyncSearch />
            </Route>
            <Route exact path="/dmv-practice-test">
              <AsyncPracticeTests />
            </Route>
            <Route exact path="/coastline-yelp-reviews">
              <Redirect to="/coastline-academy-driving-school-reviews" />
            </Route>
            <Route exact path="/coastline-academy-driving-school-reviews">
              <AsyncReviews />
            </Route>
            <Route exact path="/drivers-ed">
              <Redirect to="/courses" />
            </Route>
            <Route exact path="/courses">
              <Reload />
            </Route>
            <Route exact path="/:state/drivers-ed">
              <RedirectFromDriversEd />
            </Route>
            <Route exact path="/affiliate-signup">
              <AsyncAffiliateSignUp />
            </Route>
            <Route exact path="/:state/courses">
              <Redirect to="/courses" />
            </Route>
            <Route exact path="/hs/:state/:highschool">
              <AsyncLocationLandingHighschool />
            </Route>
            <Route exact path="/learn">
              <Redirect to="/book" />
            </Route>
            <Route exact path="/partner/:partner">
              <Redirect to="/location-search" />
            </Route>
          </Switch>
        </Suspense>
      </div>
      <Footer />
    </>
  )
}

export default StaticApp
